<template>
  <div v-if="isSearchByImage"
    class="image-search-wrapper"
    title="Search by Image">
    <i class="el-icon-camera-solid search-by-image"></i>

    <input type="file"
      ref="fileInput"
      class="file-input"
      accept="image/*"
      @change="handleFileUpload"
      title="">
  </div>
</template>

<script>
import {
  setPendingImageFiles,
  prefetchImageSearchPage,
  isImageSearchPagePrefetched
} from '@/utils/imageSearchTransfer'

export default {
  name: 'ImageSearchButton',

  props: {
    isSuit: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isSearchByImage: false
    }
  },

  created() {
    this.isSearchByImage = sessionStorage.getItem('isSearchByImage') === 'Y'
    if (this.isSearchByImage) {
      prefetchImageSearchPage()
    }
  },

  methods: {
    /**
     * 处理文件上传：内存直传 File 并立即跳转
     * @param {Event} event - 文件选择事件
     */
    handleFileUpload(event) {
      const files = event.target.files

      if (files.length > 0) {
        setPendingImageFiles(files)
        event.target.value = ''

        let loadingInstance = null
        if (!isImageSearchPagePrefetched()) {
          loadingInstance = this.$loading({
            lock: true,
            background: 'rgba(255, 255, 255, 0.7)'
          })
        }

        this.$router.push({
          path: `/product-search-image${this.isSuit ? '?isSuit=true' : ''}`
        }).catch(() => { }).finally(() => {
          if (loadingInstance) {
            loadingInstance.close()
          }
        })
      }
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.isSearchByImage = sessionStorage.getItem('isSearchByImage') === 'Y'
      if (this.isSearchByImage) {
        prefetchImageSearchPage()
      }
    })
  }
}
</script>

<style scoped>
.image-search-wrapper {
  position: relative;
  cursor: pointer;
}

.search-by-image {
  padding: 6px;
  font-size: 18px;
  color: var(--primary-color);
}

.file-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}
</style>
